import { clearAccessToken } from '#utils/cookies.ts';

export const sessionEndedReason = 'session-ended';
const sessionEndedLoginPath = `/login?reason=${sessionEndedReason}`;

export class MiaUnauthorizedError extends Error {
  constructor() {
    super('Mia rejected the session (401).');
  }
}

export function handleMiaUnauthorized(): void {
  clearAccessToken();
  window.location.assign(sessionEndedLoginPath);
}
